<template>
  <el-dialog
    append-to-body
    title="修改密码!"
    :visible="visible"
    width="500px"
    custom-class="loginDialog"
    :close="close"
    :close-on-click-modal="false"
    :before-close="close"
  >
    <el-form
      :model="loginForm"
      :rules="rules"
      ref="loginForm"
      style="margin: 0 auto; width: 400px"
      label-width="70px"
    >
      <el-form-item label="旧密码" prop="oldPassword">
        <el-input
          v-model="loginForm.oldPassword"
          placeholder="请输入旧密码"
          type="password"
        >
        </el-input>
      </el-form-item>
      <el-form-item label="新密码" prop="newPassword">
        <el-input
          v-model="loginForm.newPassword"
          placeholder="请输入新密码"
          type="password"
        >
        </el-input>
      </el-form-item>
      <el-form-item label="新密码" prop="newPassword1">
        <el-input
          v-model="loginForm.newPassword1"
          placeholder="请再次输入新密码"
          type="password"
        >
        </el-input>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button size="small" @click="close">取 消</el-button>
      <el-button type="primary" size="small" :loading="loading" @click="login"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { updateUserPwd } from "@/api/user";
export default {
  name: "LoginDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const validatePass = (rules, value, callback) => {
      if (!value) {
        callback(new Error("请输入密码"));
      } else if (value !== this.loginForm.newPassword) {
        callback(new Error("请输入两次密码输入不一致"));
      } else {
        callback();
      }
    };
    return {
      loginForm: {
        oldPassword: "",
        newPassword: "",
        newPassword1: "",
      },
      codeUrl: "",
      showPassword: false,
      rules: {
        oldPassword: [
          { required: true, message: "请输入旧密码", trigger: "blur" },
        ],
        newPassword: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          {
            min: 6,
            max: 20,
            message: "长度在 6 到 20 个字符",
            trigger: "blur",
          },
        ],
        newPassword1: [
          { required: true, validator: validatePass, trigger: "blur" },
        ],
      },
      loading: false,
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.loginForm.resetFields();
        })
      }
    },
  },
  methods: {
    close() {
      this.$emit("update:visible", false);
    },
    login() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          // 登录
          this.loading = true;
          updateUserPwd(this.loginForm)
            .then((res) => {
              this.$message.success("修改成功");
              this.$store.dispatch("logout");
              this.close();
              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    },
  },
};
</script>

<style scoped lang="less" >
.eye-icon {
  cursor: pointer;
  width: 15px;
  margin-right: 5px;
}
</style>